import React, { useState, useEffect } from 'react';
import {
  Button,
  Typography,
} from '@mui/material';


const ProjectResources = ({ projectId, fetchProjectResources }) => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (projectId) {
      loadResources();
    }
  }, [projectId]);

  const loadResources = async () => {
    setLoading(true);
    try {
      const fetchedResources = await fetchProjectResources;
      const filteredResources = fetchedResources
        ?.filter((res) => res.id === projectId)
        .map(({ title, pdfUrl }) => ({ title, url: pdfUrl })) || [];
      setResources(filteredResources);
    } catch (error) {
      console.error('Error fetching resources:', error);
    } finally {
      setLoading(false);
    }
  };
  return (

    <div className="p-4 bg-white rounded-lg shadow-md">
      <Typography variant="h6" gutterBottom>
        Project Resources
      </Typography>
      {resources.length === 0 && !loading && (
        <Typography variant="body1" color="textSecondary" align="center">
          No resources available for this project.
        </Typography>
      )}

      <ul className="divide-y divide-gray-200">
        {resources.map((item) => (
          <li key={item.id} className="flex justify-between items-center py-2">
            <span>{item.title}</span>
            <div className="flex items-center space-x-2 ml-auto">
              <Button
                variant="outlined"
                sx={{ mr: 1 }}
                href={item.url}
                target="_blank"
              >
                View PDF
              </Button>
              <Button
                variant="contained"
                size="small"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectResources;
